'use client';

import TrackOrderForm from '@/components/TrackOrderForm';
import TrackOrderSignIn from '@/components/TrackOrderSignIn';
import { useUserContext } from '@/context/user';
import classes from './trackOrderPage.module.css';

const TrackOrderPage = () => {
  const [{ isSignedIn }] = useUserContext();

  const afterSubmit = () => {
    history.push('/order-history');
  };

  return (
    <div className={classes.root}>
      <h1 className={classes.title}>Track Your Order</h1>
      <div className={[classes.container, isSignedIn ? classes.trackingFormOnly : ' '].join(' ')}>
        <div className={classes.trackingForm}>
          <h2 className={classes.formTitle}>Tracking by Email</h2>
          <TrackOrderForm />
        </div>

        {isSignedIn ? null : (
          <div className={classes.signInForm}>
            <h2 className={classes.formTitle}>Login to Track</h2>
            <TrackOrderSignIn
              afterSubmit={afterSubmit}
              showTitle={false}
              showFooter={false}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default TrackOrderPage;
